import { TreatmentApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const treatmentApi = new TreatmentApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
